import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import definitions from './definitions'
import lead from './lead'

export default new Vuex.Store({
    modules: {
        definitions,
        lead
    }
});